"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LandingLayout;
const react_1 = __importDefault(require("react"));
const header_1 = __importDefault(require("./header/header"));
const footer_1 = __importDefault(require("../default/footer/footer"));
const salesforce_1 = require("~/contexts/salesforce");
const main_class_1 = __importStar(require("~/contexts/main-class"));
const language_1 = __importDefault(require("~/contexts/language"));
const react_modal_1 = __importDefault(require("react-modal"));
const classnames_1 = __importDefault(require("classnames"));
require("./landing.scss");
function LandingLayout({ children, data }) {
    // BrowserRouter has to include everything that uses useLocation
    var _a, _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("header", { className: "landing-page-header" },
            react_1.default.createElement(header_1.default, { links: (_b = (_a = data.layout[0]) === null || _a === void 0 ? void 0 : _a.value.navLinks) !== null && _b !== void 0 ? _b : [] })),
        react_1.default.createElement(salesforce_1.SalesforceContextProvider, null,
            react_1.default.createElement(main_class_1.MainClassContextProvider, null,
                react_1.default.createElement(Main, { data: data }, children))),
        react_1.default.createElement("footer", { id: "footer" },
            react_1.default.createElement(footer_1.default, null))));
}
function Main({ children, data }) {
    const { language } = (0, language_1.default)();
    const ref = react_1.default.useRef(null);
    const { classes } = (0, main_class_1.default)();
    react_1.default.useEffect(() => {
        react_modal_1.default.setAppElement(ref.current);
    }, []);
    return (react_1.default.createElement("div", { id: "main", className: (0, classnames_1.default)('lang', 'layout-landing', language, classes), "data-analytics-nav": `Landing page (${data.title})`, ref: ref, tabIndex: -1 }, children));
}
